export const useUserData = () => {
  const user = localStorage.getItem('userData');
  const userData = user ? JSON.parse(user) : {};

  return { userData };
};
